module.exports = __webpack_public_path__ + "assets/media/msg-back.c16ca0c3.mp3";